import { WebPageDetails } from '@/services/analytics/platforms/adobe-analytics/models';
import { BagPageLoadEvent } from '@/services/analytics/events';
import { AdobePageLoadEvent } from './adobe-page-load';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';

export class AdobeCartPageLoadEvent extends AdobePageLoadEvent {
  constructor(event: BagPageLoadEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    Object.assign(this.web.webPageDetails, {
      pageType: 'cart',
      siteSection: 'order',
      subPageName: 'cart',
      subPageViews: { value: 1 },
      name: `order:cart`,
    } as WebPageDetails);
  }
}
